import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CATEGORIES, SERVICES } from "../data/salon";
import { finalPrice, toFa } from "../lib/format";
import { useStagger } from "../lib/motion";
import ServiceCard from "../components/ui/ServiceCard";
import PageHero from "../components/ui/PageHero";
import { Pill } from "../components/ui/Bits";
import { useDocumentTitle } from "../lib/title";
import "./pages.css";

const SORTS = [
  { slug: "popular", label: "محبوب‌ترین", fn: (a, b) => b.reviews - a.reviews },
  { slug: "cheap", label: "ارزان‌ترین", fn: (a, b) => finalPrice(a) - finalPrice(b) },
  { slug: "pricey", label: "گران‌ترین", fn: (a, b) => finalPrice(b) - finalPrice(a) },
  { slug: "quick", label: "کوتاه‌ترین", fn: (a, b) => a.duration - b.duration },
];

export default function Services() {
  useDocumentTitle("خدمات سالن");
  const [params, setParams] = useSearchParams();
  const active = params.get("c");
  const [sort, setSort] = useState("popular");

  const grid = useStagger({ step: 60 });

  const list = useMemo(() => {
    const base = active ? SERVICES.filter((s) => s.category === active) : SERVICES;
    return [...base].sort(SORTS.find((s) => s.slug === sort).fn);
  }, [active, sort]);

  const setCategory = (slug) => {
    if (!slug) setParams({}, { replace: true });
    else setParams({ c: slug }, { replace: true });
  };

  return (
    <>
      <PageHero
        eyebrow="ALL SERVICES"
        title="خدمات سالن"
        lede="بیست خدمت در پنج حوزه تخصصی. قیمت‌ها نهایی‌اند و در سالن تغییر نمی‌کنند."
      />

      <section className="section plist">
        <div className="wrap wrap--wide">
          <div className="plist__bar">
            <div className="plist__cats">
              <Pill active={!active} onClick={() => setCategory(null)}>همه</Pill>
              {CATEGORIES.map((c) => (
                <Pill key={c.slug} active={active === c.slug} onClick={() => setCategory(c.slug)}>
                  {c.label}
                </Pill>
              ))}
            </div>

            <label className="plist__sort">
              <span className="sr-only">مرتب‌سازی</span>
              <select value={sort} onChange={(e) => setSort(e.target.value)}>
                {SORTS.map((s) => (
                  <option key={s.slug} value={s.slug}>{s.label}</option>
                ))}
              </select>
            </label>
          </div>

          <p className="plist__count">{toFa(list.length)} خدمت</p>

          {list.length === 0 ? (
            <div className="empty">
              <h3>خدمتی پیدا نشد</h3>
              <p>در این دسته‌بندی هنوز خدمتی ثبت نشده است.</p>
            </div>
          ) : (
            <div className="plist__grid" ref={grid}>
              {list.map((s) => (
                <div key={s.id} className="reveal" data-stagger="">
                  <ServiceCard service={s} />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
